import axios from '../utils/axios';
import Constants from './types';
import { getSessionId, getPayloadFromError, getEntityById } from '../utils';

export const getValueMergeOperations = (entityId, theSessionId) => {
  const sessionId = theSessionId ? theSessionId : getSessionId();
  return dispatch => {
    dispatch(getValueMergeOperationsRequest());
    axios({
      method: 'get',
      url: '/openempi-ws-rest/1.0/value-merge-operations',
      headers: {
        Accept: 'application/json',
        OPENEMPI_SESSION_KEY: sessionId
      },
      params: {
        entityId
      }
    })
      .then(res => {
        dispatch(
          getValueMergeOperationsSuccess(
            transformValueMergeOperations(res.data)
          )
        );
      })
      .catch(err => {
        dispatch(getValueMergeOperationsFailure(err));
      });
  };
};

export const createValueMergeOperation = (entityId, valueMergeOperation) => {
  const sessionId = getSessionId();
  return dispatch => {
    axios({
      method: 'POST',
      url: '/openempi-ws-rest/1.0/value-merge-operations',
      headers: {
        Accept: 'application/json',
        'Content-type': 'application/json',
        OPENEMPI_SESSION_KEY: sessionId
      },
      params: {
        entityId: entityId
      },
      data: valueMergeOperation
    })
      .then(res => {
        dispatch(saveValueMergeOperationSuccess(res.data));
        dispatch(getValueMergeOperations(entityId, sessionId));
      })
      .catch(err => {
        dispatch(saveValueMergeOperationFailure(err));
      });
  };
};

export const deleteValueMergeOperation = (entityId, id) => {
  const sessionId = getSessionId();
  return dispatch => {
    axios({
      method: 'DELETE',
      url: '/openempi-ws-rest/1.0/value-merge-operations/' + id,
      headers: {
        Accept: 'application/json',
        'Content-type': 'application/json',
        OPENEMPI_SESSION_KEY: sessionId
      },
      params: {
        entityId: entityId
      }
    })
      .then(res => {
        dispatch(getValueMergeOperations(entityId, sessionId));
      })
      .catch(err => {
        dispatch(deleteValueMergeOperationFailure(err));
      });
  };
};

export const reverseValueMergeOperation = (entityId, id) => {
  const sessionId = getSessionId();
  return dispatch => {
    axios({
      method: 'PUT',
      url: '/openempi-ws-rest/1.0/value-merge-operations/' + id,
      headers: {
        Accept: 'application/json',
        'Content-type': 'application/json',
        OPENEMPI_SESSION_KEY: sessionId
      },
      params: {
        entityId: entityId
      }
    })
      .then(res => {
        dispatch(getValueMergeOperations(entityId, sessionId));
      })
      .catch(err => {
        dispatch(reverseValueMergeOperationFailure(err));
      });
  };
};

const transformValueMergeOperations = valueMergeOperations => {
  return valueMergeOperations.map(valueMergeOperation =>
    transformValueMergeOperation(valueMergeOperation)
  );
};

const transformValueMergeOperation = valueMergeOperation => {
  const entity = getEntityById(valueMergeOperation.entityId);
  valueMergeOperation.entity = entity ? entity.displayName : 'Unknown';
  valueMergeOperation.fromValuesStr = valueMergeOperation.fromValues.join(', ');
  return valueMergeOperation;
};

export const clearValueMergeOperationsError = () => {
  return {
    type: Constants.VALUEMERGEOPERATIONS_CLEAR_ERROR
  };
};

const getValueMergeOperationsRequest = () => {
  return {
    type: Constants.VALUEMERGEOPERATIONS_GET_REQUEST
  };
};

const getValueMergeOperationsSuccess = data => {
  return {
    type: Constants.VALUEMERGEOPERATIONS_GET_SUCCESS,
    payload: data
  };
};

const getValueMergeOperationsFailure = err => {
  if (err && err.response && err.response.status === 404) {
    return {
      type: Constants.VALUEMERGEOPERATIONS_NOT_FOUND
    };
  }
  const payload = getPayloadFromError(err);
  return {
    type: Constants.VALUEMERGEOPERATIONS_GET_FAILURE,
    payload
  };
};

const saveValueMergeOperationSuccess = data => {
  return {
    type: Constants.VALUEMERGEOPERATIONS_SAVE_SUCCESS,
    payload: data
  };
};

const saveValueMergeOperationFailure = err => {
  const payload = getPayloadFromError(err);
  return {
    type: Constants.VALUEMERGEOPERATIONS_SAVE_FAILURE,
    payload
  };
};

const deleteValueMergeOperationFailure = err => {
  const payload = getPayloadFromError(err);
  return {
    type: Constants.VALUEMERGEOPERATIONS_SAVE_FAILURE,
    payload
  };
};

const reverseValueMergeOperationFailure = err => {
  const payload = getPayloadFromError(err);
  return {
    type: Constants.VALUEMERGEOPERATIONS_SAVE_FAILURE,
    payload
  };
};
